<template>
  <div class="app-container">
    <NavTitle :title="title" />
    <div class="prescription-search-box">
      <div class="prescription-search-content">
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">日期范围</div>
          <div class="prescription-search-item-input">
            <el-date-picker
              v-model="queryParam.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
              :editable="false"
              size="mini"
            ></el-date-picker>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">处方类型</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.issueType"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.prescriptionType"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">处方状态</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.prescriptionStatus"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.prescriptionStatus"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">审核方式</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.prescriptionAuditType"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.prescriptionAuditType"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">用药人姓名</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.userName"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">用药人性别</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.userSex"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.sexes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">创建人</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.creatorUserName"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">审核人</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.auditUserName"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">开方机构</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.issueHospital"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">处方编号</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.number"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">科别</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.department"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">诊断</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.diagnose"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">药品名称</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.drugName"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">追溯码</div>
          <div class="prescription-search-item-input">
            <el-input
              v-model="queryParam.barcodeNo"
              placeholder="请输入"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">处方来源</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.prescriptionSource"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.prescriptionSource"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="prescription-search-item">
          <div class="prescription-search-item-label">是否付药</div>
          <div class="prescription-search-item-input">
            <el-select
              v-model="queryParam.isMedicinePaid"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.isMedicinePaid"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="prescription-search-button">
        <el-button type="primary" size="mini" @click="handleSearch"
          >查询</el-button
        >
        <el-button plain size="mini" @click="handleReset">重置</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="table-button">
        <div class="table-button-item">
          <el-button type="primary" size="mini" @click="handleCreateOrder">
            <i class="el-icon-plus"></i>
            创建
          </el-button>
          <el-button type="primary" size="mini" @click="handleGetOrder">
            <i class="el-icon-plus"></i>
            获取
          </el-button>
        </div>
        <div class="table-button-item">
          <div style="margin-right: 10px" @click="fetchList">
            <i class="el-icon-refresh-left" style="margin-right: 5px"></i>
            <span>刷新</span>
          </div>
          <div @click="handleSetPrescriptionPlatform">
            <i class="el-icon-setting" style="margin-right: 5px"></i>
            <span>配置三方平台</span>
          </div>
        </div>
      </div>
      <div class="table-d">
        <el-table
          ref="workTableRef"
          :data="tableList"
          stripe
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="400"
          @sort-change="handleSortChange"
          highlight-current-row
          :row-key="'id'"
          @row-click="handleRowClick"
          v-loading="loading"
          size="mini"
        >
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <span
                :class="['table-status blue']"
                @click="handleDetail(scope.row)"
                >查看</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="creatorUserName"
            label="创建人"
            width="100"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="addedTime"
            label="创建时间"
            width="200"
            sortable="custom"
          />
          <el-table-column
            prop="issueType"
            label="处方类型"
            width="120"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="prescriptionStatusName"
            label="处方状态"
            width="120"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="若状态有变，请刷新页面"
                placement="bottom"
              >
                <span>处方状态 <i class="el-icon-info"></i></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span
                :class="[
                  'table-state',
                  {
                    blue: scope.row.prescriptionStatusName == '审核中',
                    yellow: scope.row.prescriptionStatusName == '待审核',
                    red: scope.row.prescriptionStatusName == '未通过',
                    isClick: scope.row.prescriptionStatusName == '未通过',
                    gray: scope.row.prescriptionStatusName == '已失效',
                  },
                ]"
                @click="handleClick(scope.row)"
                >{{ scope.row.prescriptionStatusName }}
                <i
                  class="el-icon-caret-right"
                  v-if="scope.row.prescriptionStatusName == '未通过'"
                ></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="isMedicinePaid" label="是否付药" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.isMedicinePaid == '-'">{{
                scope.row.isMedicinePaid
              }}</span>
              <span
                v-else
                :class="[
                  'table-state isClick',
                  {
                    blue: scope.row.isMedicinePaid == '已付药',
                  },
                ]"
                @click="handleConfirmPay(scope.row)"
                >{{ scope.row.isMedicinePaid }}
                <i class="el-icon-caret-right"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="auditUserName"
            label="审核人"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="prescriptionAuditTypeName"
            label="审核方式"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="storeName"
            label="门店名称"
            width="250"
            sortable="custom"
          />

          <el-table-column prop="issueHospital" label="开方机构" width="250" />
          <el-table-column
            prop="number"
            label="处方编号"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="issueTime"
            label="开具时间"
            width="200"
            sortable="custom"
          />
          <el-table-column
            prop="department"
            label="科别"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="diagnose"
            label="诊断"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="userName"
            label="用药人姓名"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="userSex"
            label="用药人性别"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="userAge"
            label="用药人年龄"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="drugDetailCount"
            label="药品信息"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="prescriptionSource"
            label="处方来源"
            width="150"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            prop="submitTime"
            label="提交时间"
            width="200"
            sortable="custom"
          />
          <el-table-column
            prop="auditTime"
            label="审核时间"
            width="200"
            sortable="custom"
          />
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <TipDialog ref="TipDialogRef" />
    <GetOrder ref="GetOrderRef" @submit="fetchList" />
    <CreatePrescription ref="CreatePrescriptionRef" @success="handleSearch" />
    <DetailPrescription ref="DetailPrescriptionDetailRef" @submit="fetchList" />
    <ConfirmPay ref="ConfirmPayRef" @refresh="fetchList" />
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";
import CreatePrescription from "./components/createPrescription.vue";
import DetailPrescription from "./components/detailPrescription.vue";
import GetOrder from "./components/getOrder.vue";
import ConfirmPay from "./components/confirmPay.vue";
import NavTitle from "@/components/NavTitle/index.vue";
import { fetchList } from "@/api/article";

export default {
  name: "Prescription",
  components: {
    CreatePrescription,
    TipDialog,
    DetailPrescription,
    GetOrder,
    ConfirmPay,
    NavTitle,
  },
  data() {
    return {
      title: ["处方管理"],
      barcode: "",
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      tableList: [],
      selectedRow: null,
      filterData: {},
      queryParam: {
        date: [],
        prescriptionStatus: "",
        prescriptionAuditType: "",
        storeName: "",
        userName: "",
        userSex: "",
        creatorUserName: "",
        auditUserName: "",
        issueHospital: "",
        issueType: "",
        number: "",
        department: "",
        diagnose: "",
        drugName: "",
        barcodeNo: "",
        prescriptionSource: "",
        isMedicinePaid: "",
        orders: {
          storeName: null,
          issueTime: null,
          addedTime: null,
          submitTime: null,
          auditTime: null,
        },
      },
      loading: false,
      isSetPrescriptionPlatform: false,
    };
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    handleConfirmPay(row) {
      this.$refs.ConfirmPayRef.show(row);
    },
    handleSetPrescriptionPlatform() {
      this.$refs.GetOrderRef.show();
    },
    async handleGetOrder() {
      if (this.isSetPrescriptionPlatform) {
        await this.$api.prescription.SetPrescriptionPlatform();
        this.fetchList();
        this.$message({
          message: "获取成功",
          type: "success",
        });
        return;
      }
      this.$refs.GetOrderRef.show();
    },
    handleClick(row) {
      if (row.prescriptionStatusName === "未通过") {
        this.$refs.TipDialogRef.show({
          title: "拒绝原因",
          content: row.reason,
        });
      }
    },
    handleSortChange(value) {
      // 药店名称
      if (value.prop === "storeName") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.storeName = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.storeName = true;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.storeName = false;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
      }
      // 开方时间
      if (value.prop === "issueTime") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.issueTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.issueTime = true;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.issueTime = false;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
      }
      // 创建时间
      if (value.prop === "addedTime") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.addedTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.addedTime = true;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.addedTime = false;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.submitTime = null;
          this.queryParam.orders.auditTime = null;
        }
      }
      // 提交时间
      if (value.prop === "submitTime") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.submitTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.submitTime = true;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.auditTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.submitTime = false;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.auditTime = null;
        }
      }
      // 审核时间
      if (value.prop === "auditTime") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.auditTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.auditTime = true;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.auditTime = false;
          this.queryParam.orders.storeName = null;
          this.queryParam.orders.issueTime = null;
          this.queryParam.orders.addedTime = null;
          this.queryParam.orders.submitTime = null;
        }
      }
      this.paging.index = 1;
      this.fetchList();
    },
    handleDetail(row) {
      this.$refs.DetailPrescriptionDetailRef.show(row);
    },
    handleCreateOrder() {
      this.$refs.CreatePrescriptionRef.show();
    },
    handleSearch() {
      this.paging.index = 1;
      this.fetchList();
    },
    handleReset() {
      this.queryParam.date = [];
      this.queryParam.prescriptionStatus = "";
      this.queryParam.prescriptionAuditType = "";
      this.queryParam.storeName = "";
      this.queryParam.userName = "";
      this.queryParam.userSex = "";
      this.queryParam.creatorUserName = "";
      this.queryParam.auditUserName = "";
      this.queryParam.issueHospital = "";
      this.queryParam.issueType = "";
      this.queryParam.number = "";
      this.queryParam.department = "";
      this.queryParam.diagnose = "";
      this.queryParam.drugName = "";
      this.queryParam.barcodeNo = "";
      this.queryParam.prescriptionSource = "";
      this.queryParam.isMedicinePaid = "";
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleCurrentChange(index) {
      this.paging.index = index;
      this.fetchList();
    },
    async fetchList() {
      this.loading = true;
      const { data: tableList, extended } =
        await this.$api.prescription.GetPrescriptionManageListByPage({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = tableList.dataList || [];
      this.isSetPrescriptionPlatform = tableList.isSetPrescriptionPlatform;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async fetchData() {
      this.loading = true;
      const { data: filtersData } =
        await this.$api.prescription.GetPrescriptionManageFilters();
      this.filterData = filtersData;
      const { data: tableList, extended } =
        await this.$api.prescription.GetPrescriptionManageListByPage({
          ...this.queryParam,
          paging: this.paging,
        });
      this.tableList = tableList.dataList || [];
      this.isSetPrescriptionPlatform = tableList.isSetPrescriptionPlatform;
      this.total = extended.paging.total;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
